<div class="loaderContent">
  @if (!this.isLoading2()) {
    <div style="display: flex; justify-content: center; flex-direction: column">
      <div
        #affirmationContainer
        class="light-shade box rounded-corners"
        style="width: 100%; max-width: 900px; margin-top: 10px"
        [ngStyle]="boxHeight">
        <div style="width: 100%" class="title-bar dark-shade box-title rounded-corners-upper">
          <div>{{ affirmation?.title }}</div>
        </div>
        <div style="overflow-y: scroll; margin: 10px" [ngStyle]="textHeight">
          <div [innerHtml]="affirmation?.body"></div>
        </div>
        <div style="margin-left: 20px">
          <div style="display: flex">
            <dx-check-box [(value)]="affirmed"></dx-check-box>
            <div style="margin-left: 10px">{{ affirmation?.check_line }}</div>
          </div>
          <div style="margin-top: 10px">
            <dx-button text="Back" (onClick)="back()" icon="{{ env.assetsPath }}images/Previous_16x16.png"></dx-button>
            <dx-button
              style="margin-left: 10px"
              text="Next"
              (onClick)="next()"
              [disabled]="!affirmed"
              icon="{{ env.assetsPath }}images/Next_16x16.png"></dx-button>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <app-loading-div></app-loading-div>
  }
</div>
